<mat-toolbar class="public-footer">
	<a routerLink="/privacy">Privacy</a>&nbsp;|&nbsp;
	<a routerLink="/terms">Terms</a>
</mat-toolbar>